import themedefault from "./themedefault";
import theme2 from "./theme2";
import azetTheme from "./azetTheme";

const themes = {
  themedefault,
  theme2,
  azetTheme
};
export default themes;
